"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _clients = require("@/api/clients");
var _app = require("@/store/modules/app");
var _tagsView = require("@/store/modules/tags-view");
var _ClientGeneralTab = _interopRequireDefault(require("./ClientGeneralTab.vue"));
var _ClientAdvanceTab = _interopRequireDefault(require("./ClientAdvanceTab.vue"));
var _ClientContactTab = _interopRequireDefault(require("./ClientContactTab.vue"));
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, _clients.defaultClientData);
    this.activeIndex = 0;
    this.stepsOptions = [{
      title: 'Client',
      status: 'process',
      prevStatus: 'wait',
      description: 'Description goes here',
      icon: 'el-icon-office-building',
      component: _ClientGeneralTab.default
    }, {
      title: 'Contact',
      status: 'wait',
      prevStatus: 'wait',
      description: 'Description goes here',
      icon: 'el-icon-notebook-2',
      component: _ClientContactTab.default
    }];
  }
  get lang() {
    return _app.AppModule.language;
  }
  created() {
    if (this.isEdit) {
      this.fetchData();
    } else {
      this.formData = Object.assign({}, _clients.defaultClientData);
    }
    // Why need to make a copy of this.$route here?
    // Because if you enter this page and quickly switch tag, may be in the execution of this.setTagsViewTitle function, this.$route is no longer pointing to the current page
    // https://github.com/PanJiaChen/vue-element-admin/issues/1221
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData() {
    try {
      let id = parseInt(this.$route.params && this.$route.params.id || '0');
      if (this.formData.id) {
        id = this.formData.id;
      }
      const data = await (0, _clients.getClientById)(id);
      this.formData = data;
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (error) {
      this.$emit('error', error);
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      _tagsView.TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  stepClick(index) {
    // check if not yet saved & still in first tab
    if (!this.isEdit && this.activeIndex === 0) {
      if (index > 0) {
        this.$message({
          message: 'Kindly save client before managing ' + this.stepsOptions[index].title,
          type: 'warning'
        });
      }
      return false;
    }
    this.stepsOptions[this.activeIndex].status = this.stepsOptions[this.activeIndex].prevStatus;
    this.activeIndex = index;
    this.stepsOptions[this.activeIndex].status = 'process';
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ClientDetail',
  components: {
    ClientGeneralTab: _ClientGeneralTab.default,
    ClientAdvanceTab: _ClientAdvanceTab.default,
    ClientContactTab: _ClientContactTab.default
  }
})], default_1);
var _default = exports.default = default_1;